import { useDispatch, useSelector } from "react-redux";
import { useAccountService } from "serviceHooks";
import { AppState } from "store";
import { setCompanyAccountingDoneUntilMonth } from "store/actions/commonActions";

function useAccountingDoneUntil() {
  const dispatch = useDispatch();
  const accountService = useAccountService();
  const companyAccountingDoneUntilMonth = useSelector(
    (state: AppState) => state.common.companyAccountingDoneUntilMonth
  );

  const getCompanyAccountingDoneUntilMonth = async () => {
    if (companyAccountingDoneUntilMonth !== undefined) {
      return companyAccountingDoneUntilMonth;
    }

    const results = await accountService.accountingCompletedUntil();
    dispatch(setCompanyAccountingDoneUntilMonth(results));

    return results;
  };

  return { getCompanyAccountingDoneUntilMonth, companyAccountingDoneUntilMonth };
}

export default useAccountingDoneUntil;
